export default __webpack_public_path__ + "static/media/p14.f865d9ed.jpg";